import { ISpecialRule } from "./rules";
import { ShipWeaponFacing } from "./warfleets";

export enum WeaponType {
  BasicWeapon = 0,
  Template = 1
}

export const defaultWeapon: IWeapon = {
  id: null,
  name: "",
  range: 0,
  attacks: 1,
  specialRules: [],
  enabledGameSystems: [],
  type: WeaponType.BasicWeapon
};

export interface IWeapon {
  id: string;
  type: WeaponType;
  name: string;
  range: number;
  attacks: number;
  attacksMultiplier?: number;
  specialRules: ISpecialRule[];
  enabledGameSystems?: number[];
  parentId?: string;
  official?: boolean;
  global?: boolean;
  hasTemplateParent?: boolean;
  isInherited?: boolean;
  facing?: ShipWeaponFacing; // Warfleets
  archived?: boolean;
}

export type WeaponWithUsage = IWeapon & {
  usage?: WeaponUsage;
};
export type WeaponUsage = {
  units: any[];
  packages: any[];
  aliases: any[];
  multipliedAliases: any[];
  books: any[];
};
